import { Box, Typography } from "@mui/material";

const LoginFooter = () => {
  return (
    <Box
      component='footer'
      sx={{
        padding: "16px",
        fontSize: "12px",
        color: "#333",
      }}
    >
      <Typography variant='body2' sx={{ fontStyle: "italic", mb: 1 }}>
        <strong>Disclaimer:</strong> This application uses artificial
        intelligence (AI) to generate, summarize, and analyze meeting
        transcripts. While AI enhances efficiency and accuracy, results may
        contain errors or omissions. All transcripts should be reviewed for
        verification. This tool does not replace official records or legal
        documentation.
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography variant='body2' sx={{ fontWeight: 500, color: "#0033A0" }}>
          © 2025 World Health Organization. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default LoginFooter;
